export default "__VITE_ASSET__DJEWZLc5__"